import React from 'react'
import {
    Box,
    Heading,
    Text,
    ResponsiveContext,
} from 'grommet';

import ResponsiveGrid from "../ResponsiveGrid";
import TableRow from './TableRow'
import useWindowDimensions from "../../helpers/width";


const style = {
    table: {
        borderStyle: "solid",
        borderWidth: "1.5px",
        borderColor: '#B1B1B1',
        width: "100%"
    },
    tableHeader: {
        backgroundColor: '#FFFFFF',
        borderStyle: 'solid',
        borderColor: '#B1B1B1',
        borderWidth: '1.5px',
        borderBottomWidth: '0px',
        color: '#232C3B',
        overflow: 'hidden',
    },
    tableCellText: {
        color: '#232C3B',
        textAlign: "center",
        overflow: 'hidden',
    }
}




function Table({state, data, rowHeaders, headers, title}) {
    const { width } = useWindowDimensions()
    const size = React.useContext(ResponsiveContext);
    const len = 75 / (rowHeaders.length)
    const column = ["25%"]
    for (let x = 0; x < rowHeaders.length; x++) column.push(`${len}%`)
    const columns = {
        small: column,
        medium: column,
        large: column,
    };

    const rows = {
        small: ["auto"],
        medium: ["auto"],
        large: ["auto"],
    };
    let STATE = '';
    switch(state) {
        case "va": STATE = "Virginia"; break;
        case "nc": STATE = "North Carolina"; break;
        case "ky": STATE = "Kentucky"; break;
        case "ga": STATE = "Georgia"; break;
        case "tn": STATE = "Tennessee"; break;
        case "al": STATE = "Alabama"; break
        case "ms": STATE = "Mississippi"; break
    }
    return (
        <>
            <Heading level="2" alignSelf="start" color="appGreen" style={{paddingLeft: "10px", marginBottom: "25px"}}>
                Detailed Scoring for { title }
            </Heading>
            {
                width > 660 ?
                    <>
                        <Text>
                            See <a href="https://energydemocracyyall.org/scorecards/methodology/">methodology page</a> for details of scoring criteria
                        </Text>
                        <ResponsiveGrid
                            width="100%"
                            height="45px"
                            overrideColumns={columns}
                            overrideRows={rows}
                        >
                            <Box
                                flex={false}
                                justify="center"
                                pad="small"
                                style={style.tableHeader}
                            >
                                <Heading level="4">{state} Electric Co-ops</Heading>
                            </Box>
                            {headers.map( header => {
                                return (
                                    <Box
                                        justify="center"
                                        style={{
                                            ...style.tableHeader,
                                            ...style.tableCellText
                                        }}
                                        pad="small"
                                    >
                                        <Text
                                            style={{
                                                fontSize: size === 'small' ? '10px' : `${rowHeaders.length/(rowHeaders.length - 1.75)}vmin`,
                                                lineHeight: '10px'
                                            }}
                                        >
                                            {header}
                                        </Text>
                                    </Box>
                                )
                            })}
                        </ResponsiveGrid>
                        <div style={style.table}>
                            {data.map((datum, i) => (
                                <TableRow key={i} data={datum} headers={rowHeaders}/>
                            ))}
                        </div>
                    </>
                :
                <>
                    <Text>{width}</Text>
                    <Text>
                        To see this scoring, please switch your mobile device to horizontal view"
                    </Text>
                </>
            }
        </>
    );
}

export default Table;